/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, EmbeddedViewRef, EventEmitter, Input, Output, TemplateRef, ViewContainerRef} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {Point, Popover, PopoverOptions} from './popover';

let /** @type {?} */ openCount: number = 0;
const /** @type {?} */ waiting: Array<() => void> = [];
export class PopoverDirectiveOld {
private _popoverInstance: Popover;
private _subscription: Subscription;

     anchorElem: any;
     anchorPoint: Point;
     popoverPoint: Point;
     popoverOptions: PopoverOptions = {};
     clrPopoverOldChange = new EventEmitter<boolean>(false);
/**
 * @param {?} templateRef
 * @param {?} viewContainer
 */
constructor(private templateRef: TemplateRef<any>,
private viewContainer: ViewContainerRef) {}
/**
 * @param {?} open
 * @return {?}
 */
set clrPopoverOld(open: boolean) {
        if (open) {
            if (this.popoverOptions.allowMultipleOpen) {
                this.createPopover();
            } else {
                if (openCount === 0) {
                    this.createPopover();
                } else {
                    waiting.push(() => {
                        this.createPopover();
                    });
                }
            }
        } else {
            this.viewContainer.clear();
            this.destroyPopover();

            if (!this.popoverOptions.allowMultipleOpen) {
                if (waiting.length > 0) {
                    const /** @type {?} */ createPopoverFn = waiting.shift();
                    createPopoverFn();
                }
            }
        }
    }
/**
 * @return {?}
 */
createPopover() {
        const /** @type {?} */ embeddedViewRef: EmbeddedViewRef<any> = /** @type {?} */((
            <EmbeddedViewRef<any>>this.viewContainer.createEmbeddedView(this.templateRef)));

        // TODO: Not sure of the risks associated with using this. Find an alternative.
        // Needed for find the correct height and width of dynamically created views
        // inside of the popover. For Eg: Button Groups
        embeddedViewRef.detectChanges();

        // filter out other nodes in the view ref so we are only left with element nodes
        const /** @type {?} */ elementNodes: HTMLElement[] = embeddedViewRef.rootNodes.filter((node: any) => {
            return node.nodeType === 1;
        });

        // we take the first element node in the embedded view; usually there should only be one anyways
        this._popoverInstance = new Popover(elementNodes[0]);
        this._subscription =
            this._popoverInstance.anchor(this.anchorElem, this.anchorPoint, this.popoverPoint, this.popoverOptions)
                .subscribe(() => {
                    this.clrPopoverOldChange.emit(false);
                });
        openCount++;
    }
/**
 * @return {?}
 */
destroyPopover() {
        if (this._popoverInstance) {
            this._subscription.unsubscribe();
            this._popoverInstance.release();
            delete this._popoverInstance;
            openCount--;
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.destroyPopover();
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrPopoverOld]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'anchorElem': [{ type: Input, args: ["clrPopoverOldAnchor", ] },],
'anchorPoint': [{ type: Input, args: ["clrPopoverOldAnchorPoint", ] },],
'popoverPoint': [{ type: Input, args: ["clrPopoverOldPopoverPoint", ] },],
'popoverOptions': [{ type: Input, args: ["clrPopoverOldOptions", ] },],
'clrPopoverOldChange': [{ type: Output, args: ["clrPopoverOldChange", ] },],
'clrPopoverOld': [{ type: Input },],
};
}

function PopoverDirectiveOld_tsickle_Closure_declarations() {
/** @type {?} */
PopoverDirectiveOld.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PopoverDirectiveOld.ctorParameters;
/** @type {?} */
PopoverDirectiveOld.propDecorators;
/** @type {?} */
PopoverDirectiveOld.prototype._popoverInstance;
/** @type {?} */
PopoverDirectiveOld.prototype._subscription;
/** @type {?} */
PopoverDirectiveOld.prototype.anchorElem;
/** @type {?} */
PopoverDirectiveOld.prototype.anchorPoint;
/** @type {?} */
PopoverDirectiveOld.prototype.popoverPoint;
/** @type {?} */
PopoverDirectiveOld.prototype.popoverOptions;
/** @type {?} */
PopoverDirectiveOld.prototype.clrPopoverOldChange;
/** @type {?} */
PopoverDirectiveOld.prototype.templateRef;
/** @type {?} */
PopoverDirectiveOld.prototype.viewContainer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
